import { create } from 'apisauce';

const viaCepApi = create({
  baseURL: 'https://viacep.com.br/ws',
  headers: { Accept: 'application/vnd.github.v3+json' },
});

type ViaCepResponse =
  | { erro: true }
  | {
      cep: string;
      logradouro: string;
      complemento: string;
      bairro: string;
      localidade: string;
      uf: string;
      ibge: string;
      gia: string;
      ddd: string;
      siafi: string;
      erro?: false;
    };

type TeceoCep = {
  streetDescription: string;
  neighborhood: string;
  city: string;
  state: string;
  municipalityCode: string;
};

interface ServiceError extends Error {
  type: 'service_error';
  isNotFound: boolean;
}

const fetchFromViaCep = async (cep: string): Promise<TeceoCep> => {
  const response = await viaCepApi.get<ViaCepResponse>(`/${cep}/json`);

  if (!response.data || response.data.erro) {
    const error: ServiceError = new Error('Cep não encontrado') as ServiceError;
    error.type = 'service_error';
    error.isNotFound = Boolean(response.data?.erro);
    throw error;
  }

  return {
    streetDescription: response.data.logradouro,
    neighborhood: response.data.bairro,
    city: response.data.localidade,
    state: response.data.uf,
    municipalityCode: response.data.ibge,
  };
};

export const fetchCep = (cep: string) => fetchFromViaCep(cep);
